<template>
  <v-container>
    <v-row dense>
      <v-col v-for="(item, i) in filtered" :key="i" cols="12">
        <v-card :id="item.name" :color="item.color" dark elevation="10">
          <div class="d-flex flex-column flex-sm-row justify-space-around">
            <v-card :color="item.color" width="100%" class="mx-6 align-self-center" elevation="0">
              <v-card-text>
                <v-row class="d-flex flex-column flex-md-row justify-space-around">
                  <v-col class="ma-0" cols="auto" justify="center" align="left">
                    <v-img :max-width="50" class="rcorners" :src="item.icon"></v-img>
                  </v-col>
                  <v-col class="ma-0 align-self-center">
                    <v-card-title class="pa-0 headline" v-text="item.title"></v-card-title>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-text class="headline font-weight-bold">{{item.slogan}}</v-card-text>

              <div class="my-2">
                <v-btn
                  class="ma-2"
                  outlined
                  color="white"
                  :to="{path: `detail/${item.name}`}"
                >{{$vuetify.lang.translator("appList.moreDetailed")}}</v-btn>
                <v-btn
                  v-if="item.appStore"
                  :href="item.appStore"
                  target="_blank"
                  class="ma-2"
                  :icon="isPresentInAllStore(item)"
                  :text="isPresentInOneStore(item)"
                  color="white"
                >
                  <v-icon :left="!(isPresentInAllStore(item))">mdi-apple</v-icon>
                  {{getTextForAppstoreButton(item)}}
                </v-btn>
                <v-btn
                  v-if="item.googlePlay"
                  :href="item.googlePlay"
                  target="_blank"
                  class="ma-2"
                  :icon="isPresentInAllStore(item)"
                  :text="isPresentInOneStore(item)"
                  color="white"
                >
                  <v-icon :left="!(isPresentInAllStore(item))">mdi-google-play</v-icon>
                  {{getTextForGooglePlayButton(item)}}
                </v-btn>
              </div>
            </v-card>

            <v-card :color="item.color" width="100%" class="mr-10" elevation="0">
              <v-container>
                <v-row class="d-flex flex-column flex-md-row">
                  <v-col>
                    <div class="container">
                      <v-img
                        :style="`background-color: ${item.color};`"
                        :aspect-ratio="1"
                        :min-width="200"
                        class="rcorners"
                        :src="item.poster"
                        :alt="item.name"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-4"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-btn width="70" height="70" class="gr-code" color="white">
                        <v-img
                          :max-width="70"
                          :src="`https://file.ilook.su/public/AppInfo/${item.name}/qr.gif`"
                        ></v-img>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="auto" class="text-center pl-0">
                    <v-row class="flex-md-column ma-0 fill-height">
                      <v-col class="px-0">
                        <div style="height: 30%" class="hidden-sm-and-down"></div>
                        <v-btn
                          :disabled="!item.youtube"
                          :href="item.youtube"
                          target="_blank"
                          icon
                          color="white"
                        >
                          <v-icon x-large>mdi-youtube</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col class="px-0">
                        <div style="height: 30%" class="hidden-sm-and-down"></div>
                        <v-btn
                          :disabled="!item.instagram"
                          :href="item.instagram"
                          target="_blank"
                          icon
                        >
                          <v-icon x-large>mdi-instagram</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col class="px-0">
                        <div style="height: 30%" class="hidden-sm-and-down"></div>
                        <v-btn icon @click.stop="$store.commit('showMessageDialog', item.title)">
                          <v-icon x-large>mdi-lifebuoy</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { eventEmitter } from "../main";

export default {
  components: {},
  data() {
    return {
      date: 0,
    };
  },
  computed: {
    currentFilter() {
      return this.$route.name;
    },
    filtered() {
      if (this.currentFilter == "all") {
        return this.$store.getters.getAppItems;
      }
      return this.$store.getters.getAppItems.filter((item) => {
        return item.platforms.includes(this.currentFilter);
      });
    },
  },
  methods: {
    isPresentInAllStore(item) {
      let val =
        typeof item.appStore === "string" &&
        typeof item.googlePlay === "string";
      return val;
    },
    isPresentInOneStore(item) {
      let val =
        typeof item.appStore === "string" ||
        typeof item.googlePlay === "string";
      return val;
    },
    getTextForGooglePlayButton(item) {
      if (this.isPresentInAllStore(item)) {
        return "";
      } else {
        return "Google Play";
      }
    },
    getTextForAppstoreButton(item) {
      if (this.isPresentInAllStore(item)) {
        return "";
      } else {
        return "App Store";
      }
    },
    getColorForYoutube(item) {
      if (item.youtube) {
        return "rgba(255, 255, 255, 1)";
      } else {
        return "rgba(255, 255, 255, 0.5)";
      }
    },
    update() {
      // if (!this.$router.currentRoute.meta.isRoot) {
      //   return;
      // }
      this.$store.dispatch("updateAppsAction", {
        lang: this.$vuetify.lang.current,
      });
    },
  },
  watch: {},
  mounted() {
    this.update();
    let sheet = document.getElementById("scrolling_sheet");

    sheet.onscroll = function () {
      // console.log(123);
      this.date = Date();
      // sheet.style.color = "red";
    };
  },
  created() {
    eventEmitter.$on("updateLocale", this.update);
  },
  beforeDestroy() {
    eventEmitter.$off("updateLocale", this.update);
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  position: relative;
}
.vertical-center {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.gr-code {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
</style>